<template lang="pug">
#admin_container.container-small
  h1#container_title 맥주 레시피 관리 글수정
  .container_wr
    #s41.sub
      .inner
        .total_board_view_wrap.board_table
          #bo_v_con
            table.guest_table.req_table
              colgroup
                col(width='120')
                col(width='160')
                col(width='120')
                col
              tbody
                tr
                  th 한글 제목
                  td(colspan="3")
                    input.frm_input.full_input(v-model='res.KR_NAME')
                tr
                  th 영어 제목
                  td(colspan="3")
                    input.frm_input.full_input(v-model='res.EN_NAME')
                tr
                  th 맥주 번호
                  td(colspan="3")
                    input.frm_input(type='number' v-model='res.BEER_NUM')
                tr
                  th ABV
                  td(colspan="3")
                    input.frm_input(type='number' v-model='res.ABV')
                    | %
                tr
                  th IBU
                  td(colspan="3")
                    input.frm_input(type='number' v-model='res.IBU')
                tr
                  th Aroma
                  td(colspan="3")
                    input.frm_input.full_input(v-model='res.AROMA')
                tr
                  th 한 줄 설명
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.SIMPLE_EXPLAIN')
                tr
                  th 자세한 설명
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.DETAILED_EXPLAIN')
                tr
                  th 어울리는 음식
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.FOOD')
                tr
                  th 한 줄 설명
                    br
                    span (영문)
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.EN_SIMPLE_EXPLAIN')
                tr
                  th 자세한 설명
                    br
                    span (영문)
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.EN_DETAILED_EXPLAIN')
                tr
                  th 어울리는 음식
                    br
                    span (영문)
                  td(colspan="3")
                    textarea.frm_input.full_input(v-model='res.EN_FOOD')
                tr
                  th 리스트 이미지
                  td(colspan="3")
                    .bo_w_file.write_div
                      .file_wr.write_div(v-if="res.LIST_IMG == '' || upload[0].flag")
                        font-awesome-icon.fa.fa_download(icon='download')
                        input#bf_file_1.frm_file(type='file' @change='onInputImage(1)' ref='fileUpload1')
                      .file_del(v-if="res.LIST_IMG && res.LIST_IMG !== ''")
                        input(type='checkbox' v-model="upload[0].flag")
                        label(:class='[upload[0].flag ? "cancel" : ""]') {{res.LIST_IMG}} 파일 삭제
                tr
                  th 상세 이미지
                  td(colspan="3")
                    .bo_w_file.write_div
                      .file_wr.write_div(v-if="res.DETAILED_IMG == '' || upload[1].flag")
                        font-awesome-icon.fa.fa_download(icon='download')
                        input#bf_file_2.frm_file(type='file' @change='onInputImage(2)' ref='fileUpload2')
                      .file_del(v-if="res.DETAILED_IMG && res.DETAILED_IMG !== ''")
                        input(type='checkbox' v-model="upload[1].flag")
                        label(:class='[upload[1].flag ? "cancel" : ""]') {{res.DETAILED_IMG}} 파일 삭제
          .board_button.center
            a#btn_submit(@click='editBeer()') 확인
            a(@click='$_goTo({name: "beer-admin"})') 목록
    
</template>

<script>
export default {
  components: {},
  data() {
    return {
      args: {
        idx: this.$route.params.idx,
      },
      files: {
        listImg: '',
        detailImg: '',
      },
      upload: [
        {
          path: '',
          files: '',
          flag: false,
        },
        {
          path: '',
          files: '',
          flag: false,
        },
      ],
      res: {
        LIST_IMG: '',
        DETAILED_IMG: '',
      },
      nextprev: [],
      checked: [],
      flagData: {
        editFlag: false,
        allChecked: false,
        descList: true,
      },
    };
  },
  computed: {},
  methods: {
    async getData() {
      await this.$_admin_get('admin/beer/detail', this.args)
        .then(res => {
          this.res = res.data.res[0];
          this.res.LIST_IMG = res.data.res[0].LIST_IMG.split('beer_img/')[1];
          this.res.DETAILED_IMG =
            res.data.res[0].DETAILED_IMG.split('beer_img/')[1];
        })
        .catch(() => {});
    },
    async editBeer() {
      if (this.res.KR_NAME == '') {
        alert('한글 제목을 입력해주세요.');
        return;
      } else if (this.res.EN_NAME == '') {
        alert('영어 제목을 입력해주세요.');
        return;
      } else if (this.res.BEER_NUM == '') {
        alert('맥주 번호를 입력해주세요.');
        return;
      } else if (this.res.ABV == '') {
        alert('ABV를 입력해주세요.');
        return;
      } else if (this.res.IBU == '') {
        alert('IBU를 입력해주세요.');
        return;
      } else if (this.res.SIMPLE_EXPLAIN == '') {
        alert('한 줄 설명을 입력해주세요.');
        return;
      } else if (this.res.FOOD == '') {
        alert('어울리는 음식을 입력해주세요.');
        return;
      } else if (this.res.AROMA == '') {
        alert('Aroma를 입력해주세요.');
        return;
      } else if (this.res.DETAILED_EXPLAIN == '') {
        alert('자세한 설명을 입력해주세요.');
        return;
      } else if (this.res.EN_FOOD == '') {
        alert('어울리는 음식(영문)을 입력해주세요.');
        return;
      } else if (this.res.EN_DETAILED_EXPLAIN == '') {
        alert('자세한 설명(영문)을 입력해주세요.');
        return;
      } else if (this.res.EN_SIMPLE_EXPLAIN == '') {
        alert('한 줄 설명(영문)을 입력해주세요.');
        return;
      }

      const formData = new FormData();

      if (this.upload[0].flag && typeof this.files.listImg == 'object') {
        // NOTE: 원본 삭제 & 새로운 파일 첨부
        const firstBlob = new Blob([this.files.listImg], {
          type: this.files.listImg.type,
        });
        formData.append('LIST_IMG', firstBlob, this.files.listImg.name);
      } else if (this.upload[0].flag && typeof this.files.listImg == 'string') {
        // NOTE: 원본 삭제 & 새로운 파일 첨부하지 않음
        alert('리스트 이미지를 첨부해주세요.');
        return;
      }

      if (this.upload[1].flag && typeof this.files.detailImg == 'object') {
        const secBlob = new Blob([this.files.detailImg], {
          type: this.files.detailImg.type,
        });
        formData.append('DETAILED_IMG', secBlob, this.files.detailImg.name);
      } else if (
        this.upload[1].flag &&
        typeof this.files.detailImg == 'string'
      ) {
        alert('상세 이미지를 첨부해주세요.');
        return;
      }

      for (var col of [
        'BEER_NUM',
        'KR_NAME',
        'EN_NAME',
        'ABV',
        'IBU',
        'SIMPLE_EX',
        'FOOD',
        'AROMA',
        'DETAILED_EXPLAIN',
        'EN_DETAILED_EXPLAIN',
        'EN_SIMPLE_EXPLAIN',
        'EN_FOOD',
      ]) {
        formData.append(col, this.res[col]);
      }
      formData.append('IDX', this.args.idx);

      await this.$_upLoad('put', 'admin/beer/edit', formData).then(res => {
        if (res) {
          alert('수정이 완료되었습니다.');
          this.$_goTo({
            name: 'beer-detail-admin',
            params: { idx: this.args.idx },
          });
        } else {
          alert('수정에 실패하였습니다.');
          return;
        }
      });
    },
    onInputImage(num) {
      if (num == 1) {
        this.files.listImg = this.$refs.fileUpload1.files[0];
      }
      if (num == 2) {
        this.files.detailImg = this.$refs.fileUpload2.files[0];
      }
    },
  },
  beforeMount() {},
  mounted() {
    this.getData();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/board.css';
.fa_download {
  margin-right: 5px;
}
.board_btn {
  padding: 20px;
}
.center {
  text-align: center !important;
}
.inner .board_table .board_button a#btn_submit {
  padding: 10px 25px;
  background: #333;
  color: #fff;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
.board_list {
  clear: both;
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-top: 2px solid #1f1f1f;
}
.board_list th {
  background: #fafafa;
  font-weight: normal;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  height: 46px;
  color: #333;
}
.board_list td.subject {
  text-align: left;
}
.board_list td.subject a {
  margin-left: 20px;
}
.board_list td {
  border-bottom: 1px solid #eee;
  height: 40px;
  text-align: center;
}
table td {
  line-height: 22px;
}
#s41.sub {
  padding: 0;
  padding-top: 30px;
}

.edit_btn {
  margin-top: 50px;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  font-size: 13px;
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.board_button a.newb {
  background: #2c2c2c;
  color: #fff;
  cursor: pointer;
}
em img {
  margin-right: 13px;
}
.file_del input {
  margin-right: 5px;
}
.cancel {
  text-decoration: line-through !important;
}
.bo_w_file {
  display: flex;
}
.file_del {
  line-height: 44px;
}
</style>
